import type { Doc } from "building-types/doc";
import type { RoomEdgeHandle, RoomHandle, RoomLayoutHandle } from "building-types/handles/docEntityHandleTypes";
import type { RoomLayoutEntityType } from "building-types/roomLayouts/roomLayoutTypes";
import { roomLayoutEntityHandleFromTypeAndId } from "../rooms/layout/roomLayoutTools";
import { docAddEntityToRoomLayout } from "./docAddEntityToRoomLayout";

export function docAddEntityToRoomLayoutIfRoomLayoutHandle(
  handle: RoomHandle | RoomLayoutHandle | RoomEdgeHandle,
  doc: Doc,
  entityType: RoomLayoutEntityType,
  entityId: string,
) {
  if (handle.type === "ROOM_LAYOUT") {
    doc = docAddEntityToRoomLayout(doc, handle.id, roomLayoutEntityHandleFromTypeAndId(entityType, entityId));
  }
  return doc;
}
